
import { NON_PROD_ERP_SYSTEM_OPTIONS } from 'src/app/models/constants';

export const environment = {
  "production": false,
  "erpSystemOptions": NON_PROD_ERP_SYSTEM_OPTIONS
};